import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import Loading from 'src/components/lib/loading/loading';

import css from './more-button.css';


const MoreButton = ({
  loadingMore,
  ...props
}: {
  loadingMore: boolean;
  onClick: (evt: React.SyntheticEvent) => unknown;
}): React.ReactElement<React.ComponentProps<'button'>> => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <button className={css.moreButton} disabled={loadingMore} {...props}>
      {loadingMore ? <Loading /> : t('More', 'More')}
    </button>
  );
};

export default MoreButton;
